import React, { Component } from 'react';
import Decimal from 'decimal.js';

class TransferDetails extends Component {
  item(text,val,noTop){
    return(
      <div className="row mi">
        <h6 className='leftInfo'><b>{text}</b></h6>
        <h6 className="rightInfo">{val}</h6>
      </div>
    )
  }
  render() {

    let amount = this.props.amount ? new Decimal(this.props.amount) : new Decimal(0)
    let Fee = this.props.fee ? new Decimal(this.props.fee) : new Decimal(0)

    let total = `${amount.add(Fee).toNumber()} ${this.props.chain}`;
    let fee = `${Fee.toNumber()} ${this.props.chain}`

    if(['emb','dai','usdt'].includes(this.props.chain.toLowerCase())){
      total = `${amount.toNumber()} ${this.props.chain}  + ${Fee.toNumber()} ETH `;
      fee = `${Fee.toNumber()} ETH `;
    }

    return (
      <div className='row mbd'>
        {this.item('From',this.props.from,true)}
        {this.item('To',this.props.to)}
        {this.item('Amount',`${this.props.amount} ${this.props.chain.replace('NRG','OL')}`)}
        {this.item('Fee',fee.replace('NRG','OL'))}
        {this.item('Total',total.replace('NRG','OL'))}
      </div>
		)
  }
}

export default TransferDetails;
